/**
 * package-admin API — a `package/02-admin` read-view kliens (BE-S1 seam, @kgc/packages).
 *
 * A `PackageAdminResponseSchema` (Zod) RUNTIME-validálja a választ → a mock-first FE a pinnelt
 * kontraktushoz illeszkedik (drift azonnal kiderül). A BE a #374 óta a `GET /api/v1/packages/:id/admin`
 * endpointon a frozen seam-et szolgálja ki (toAdminDTO + P4 drift-guard) → a route élesben is él,
 * az MSW dedicated-handler (id-gate + fall-through) dev-convenience marad.
 */
import { PackageAdminResponseSchema, type PackageAdminResponse } from '@kgc/packages/package-admin';

import { api } from './client';

export async function getPackageAdmin(id: string): Promise<PackageAdminResponse> {
  const raw = await api.get<unknown>(`/packages/${id}/admin`);
  // runtime seam-validation a pinnelt Zod-kontraktusra (z.coerce.date a dátumokra)
  return PackageAdminResponseSchema.parse(raw);
}
